export function getHomePath(role?: string | null): string {
  return role?.toLowerCase() === 'admin' ? '/org' : '/reports';
}
